import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Select, Store } from '@ngxs/store';
import { CommonService, Config, GetProviderEndpoints, NetworkMember, ProviderEndpoint, ProviderEndpointStateModel, ProviderEndpointPage } from 'huddyapi';

import moment_ from 'moment';
import { Observable, Subscription } from 'rxjs';
import { DocumentsDialog } from '../../components/documents/documents-dialog';
import { EditProviderEndpointDialog } from '../../components/edit-provider-endpoint-dialog/edit-provider-endpoint-dialog.component';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';



const moment = moment_;

@Component({
  selector: 'provider-endpoints',
  templateUrl: './provider-endpoints.component.html',
  styleUrls: ['./provider-endpoints.component.scss']
})
export class ProviderEndpointsComponent implements OnInit {


  @Select(state => state.providerEndpointState) providerEndpointState$: Observable<ProviderEndpointStateModel>;
  providerEndpointSubscription : Subscription;
  endpointPage : ProviderEndpointPage;
  filter : string = '';
  endpoints : ProviderEndpoint[];

  static PAGE_SIZE : number = 10;
  static PAGE_SIZE_OPTIONS = [ProviderEndpointsComponent.PAGE_SIZE, ProviderEndpointsComponent.PAGE_SIZE * 2, ProviderEndpointsComponent.PAGE_SIZE * 5];

  constructor(
    private store : Store,
    public dialog: MatDialog,
    public matIconRegistry : MatIconRegistry,
    private domSanitizer : DomSanitizer,
    private http: HttpClient, private sharedService: CommonService, private config: Config
  ) {
    this.store.dispatch(new GetProviderEndpoints(false, 0, ProviderEndpointsComponent.PAGE_SIZE, ''));
    this.matIconRegistry.addSvgIcon('search',  domSanitizer.bypassSecurityTrustResourceUrl('./assets/content-icon/ic-02.svg'));
  }

  ngOnInit(): void {
    this.  providerEndpointSubscription  = this.providerEndpointState$.subscribe((providerEndpointState: ProviderEndpointStateModel) => {
      console.log(providerEndpointState);
      if (providerEndpointState && providerEndpointState.endpointPage) {
        this.endpointPage = providerEndpointState.endpointPage;
         this.endpoints = [].concat(this.endpointPage.content
          .filter(endpoint  => endpoint.registrationId != 'Huddy') as ProviderEndpoint[]);
      }
      console.log(this.endpointPage, this.endpoints);   
    });

    

  }

  getColorFromName(name : string, fromPatient? :boolean) : string {
    let ret : string = '#DAC7FD';
    if (name) {
      ret = NetworkMember.getColorForName(name);
      if (ret === 'avatarColor0') {
        ret = '#DAC7FD';
      } else if (ret === 'avatarColor1') {
        ret = '#F06D82';
      } else if (ret === 'avatarColor2') {
        ret = '#75C5EC';
      } else if (ret === 'avatarColor3') {
        ret = '#A7C2EF';
      }
    }
    return ret;
  }

  edit(endpoint : ProviderEndpoint) {
    let data = {};
    this.dialog.open(DocumentsDialog, {
      width: '600px',
      height: '500px',
      data: data
    });
  }

  onEdit(data : any) {

    console.log(data);
    if (data === null) {
      //add
      data = {
        id: -1,
      }
    } 
    this.dialog.open(EditProviderEndpointDialog, {
      width: '600px',
      height: '425px',
      data: data
    });
  }

  onTest(endpoint : ProviderEndpoint) {
    console.log('onTest', endpoint);
    const headers = this.sharedService.getAuthenticationHeaders().append('allowDupes', 'true');
    var params : HttpParams = new HttpParams().append('registrationId', endpoint.registrationId);
    this.http.get(this.config.getEndpoint() + '/provider-endpoint-test', { headers: headers, params: params })
        .pipe(map((response: any) => window.open(response.url, '_blank'), (error: any) => {
            throw error;
        })).subscribe(response => console.log("done"));
  }

  search($event) {
  
    console.log($event,this.filter, $event.target.value);
    this.getPageOfEndpoints(0, ProviderEndpointsComponent.PAGE_SIZE);
  }
  
  clearSearchField() {
    this.filter = '';
    this.getPageOfEndpoints(0, ProviderEndpointsComponent.PAGE_SIZE);
  }

  getPageOfEndpoints(offset : number, size : number) {
    this.store.dispatch(new GetProviderEndpoints(false, offset, size, this.filter));
  }

  checkSearchValue($event) {
    this.filter = this.filter.replace(/[^a-zA-Z0-9 '-.]/g, '');
  }

cd 
  getNumberOfEndpoints() : number {
    let ret : number = 0;
    if (this.endpointPage) {
     ret = this.endpointPage.totalElements-1;
    }
    return ret;
  }

  pageEndpoints($event) {
    this.getPageOfEndpoints($event.pageIndex, $event.pageSize);
  }
  getPageNumber() : number {
    let ret : number = 0;
    if (this.endpointPage) {
      ret = this.endpointPage.number;
    }
    return ret;
  }
  getPageSizeOptions() : number[] {
    return ProviderEndpointsComponent.PAGE_SIZE_OPTIONS;
  }
  
}